import React, { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, MobileHeader } from './Sidebar';
import AddToHomeScreenPopup from '../AddToHomeScreenPopup';
import NewsDropdown from '../NewsDropdown';
import SearchDialog from '../SearchDialog';
import { Search } from 'lucide-react';
import { Button } from '../ui/button';

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  // Global Ctrl+K / Cmd+K shortcut
  const handleKeyDown = useCallback((e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      setSearchOpen((prev) => !prev);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="flex-1 flex flex-col min-w-0">
        <MobileHeader onMenuClick={() => setSidebarOpen(true)} onSearchClick={() => setSearchOpen(true)} />
        
        {/* Desktop top bar - search + news bell */}
        <div className="hidden lg:flex items-center justify-end gap-1 px-8 pt-2 -mb-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setSearchOpen(true)}
            className="gap-2 text-muted-foreground hover:text-foreground h-8 px-2.5"
          >
            <Search className="h-4 w-4" />
            <span className="text-xs">Поиск</span>
            <kbd className="hidden sm:inline-flex h-5 items-center gap-0.5 rounded border bg-muted px-1.5 text-[10px] font-medium text-muted-foreground/70 ml-1">
              Ctrl K
            </kbd>
          </Button>
          <NewsDropdown />
        </div>

        <main className="flex-1 px-4 py-2 md:px-6 md:py-3 lg:px-8 lg:py-4">
          <Outlet />
        </main>
      </div>

      <AddToHomeScreenPopup />
      <SearchDialog open={searchOpen} onOpenChange={setSearchOpen} />
    </div>
  );
}
